import script from "./SobreMi.vue?vue&type=script&setup=true&lang=ts"
export * from "./SobreMi.vue?vue&type=script&setup=true&lang=ts"

import "./SobreMi.vue?vue&type=style&index=0&id=7aeb88e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7aeb88e8"]])

export default __exports__